import adminApiFetch from './apiService';

export const webhookDeliveryService = {
  getList: async (params) => {
    const query = new URLSearchParams(params).toString();
    const response = await adminApiFetch(`webhook_deliveries?${query}`);
    return response.json();
  },
  getRecords: async (params) => {
    const response = await adminApiFetch('webhook_deliveries/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },
  get: (id) => adminApiFetch(`webhook_deliveries/${id}`),
  retry: (id) => adminApiFetch(`webhook_deliveries/${id}/retry`, { method: 'POST' }),
};
